import React from "react";

import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";
import type { SxProps } from "@mui/material";

import Link, { LinkProps } from "@rui/Link";
import TooltipWrapper from "@rui/TooltipWrapper";

interface BillingLinkButtonProps extends LoadingButtonProps {
  children: React.ReactNode;
  disabledTooltip?: string;
  sx?: SxProps;
  testId?: string;
  to?: LinkProps["to"];
  openInBrowser?: LinkProps["openInBrowser"];
  href?: LinkProps["href"];
}

const DEFAULT_STYLE = {
  width: "fit-content",
  height: "40px",
  borderRadius: "4px",
};

const BillingLinkButton = ({
  children,
  disabledTooltip,
  href,
  openInBrowser,
  sx,
  testId,
  to,
  variant = "contained",
  ...props
}: BillingLinkButtonProps) => {
  if ((href || openInBrowser) && !props.disabled) {
    return (
      <Link href={href} openInBrowser={Boolean(to)} to={to}>
        <LoadingButton
          data-test-id={testId}
          sx={{ ...DEFAULT_STYLE, ...sx }}
          variant={variant}
          {...props}
        >
          {children}
        </LoadingButton>
      </Link>
    );
  }

  return (
    <TooltipWrapper
      show={props.disabled ?? false}
      title={
        disabledTooltip ??
        "You are not authorized to make changes to the billing plan for your Workspace"
      }
    >
      <LoadingButton
        data-test-id={testId}
        sx={{ ...DEFAULT_STYLE, ...sx }}
        variant={variant}
        {...(to ? { component: Link, to } : {})}
        {...props}
      >
        {children}
      </LoadingButton>
    </TooltipWrapper>
  );
};

export default BillingLinkButton;
